import { createListenerMiddleware } from '@reduxjs/toolkit';

import { getCurrencyInfo } from '../../utils/getCurrencyInfo';
import { fetchUserInfoAction } from '../apiActions/fetchUserInfoAction';
import type { CoreRootState } from '../CoreStore';
import { gameStateActions } from '../slices/game/slice';

export const localisationMiddleware = createListenerMiddleware<CoreRootState>();

// TODO: get rid of me in scope of https://pragmaticplay.atlassian.net/browse/UIC-479
localisationMiddleware.startListening({
  actionCreator: fetchUserInfoAction.fulfilled,
  effect: (_action, { dispatch, getState }) => {
    const state = getState();
    const locale = state.settings.language.current;
    const currency = state.gameState.currency;

    if (locale && currency) {
      dispatch(gameStateActions.setCurrencyInfo(getCurrencyInfo(currency, locale)));
    }
  },
});
